import { apiFetch, apiPut } from '@/lib/api-client';

export async function getSetting(key: string) {
  try {
    return await apiFetch<string | null>(`/api/settings/${encodeURIComponent(key)}`);
  } catch {
    return null;
  }
}

export async function getSettings(keys?: string[]) {
  try {
    const q = keys?.length ? `?keys=${encodeURIComponent(keys.join(','))}` : '';
    return await apiFetch<Record<string, string>>(`/api/settings${q}`);
  } catch {
    return {};
  }
}

export async function updateSettings(settings: Record<string, string>) {
  return apiPut<{ success: boolean; error?: string }>('/api/settings', settings);
}
